<template lang="pug">
transition(name="update")
  .update(v-if="updateAvailable" role="status" aria-live="polite")
    i.uil.uil-rocket.update__icon
    .update__copy
      p.update__title {{ $t("setting.update_title") }}
      p.update__text {{ $t("setting.update_text") }}
    button.update__action(type="button" :disabled="updating" @click="applyUpdate")
      i.uil.uil-spinner-alt.update__spinner(v-if="updating")
      span(v-else) {{ $t("setting.update_action") }}
</template>

<script>
import useAppUpdate from "@/composables/useAppUpdate";

export default {
  setup() {
    const { updateAvailable, updating, applyUpdate } = useAppUpdate();
    return { updateAvailable, updating, applyUpdate };
  },
};
</script>

<style lang="scss" scoped>
.update {
  @apply fixed z-50 inset-x-4 bottom-4;
  @apply flex items-center gap-3;
  @apply bg-white rounded-xl border border-bluegray-100 shadow-bluegray-400-xl;
  @apply p-4;

  @screen sm {
    @apply inset-x-auto right-6 bottom-6 max-w-md;
  }

  &__icon {
    @apply flex-shrink-0 text-2xl leading-none text-gignetblue-400;
  }

  &__copy {
    @apply flex-1 min-w-0;
  }

  &__title {
    @apply text-sm font-semibold text-bluegray-700;
  }

  &__text {
    @apply text-sm leading-snug text-bluegray-500;
  }

  &__action {
    @apply flex-shrink-0 px-4 py-2 rounded-lg;
    @apply text-sm font-semibold text-white whitespace-nowrap;
    @apply bg-gignetblue-400 shadow-gignetblue-400-md;
    @apply outline-none transition-all duration-200;

    &:hover:not(:disabled) {
      @apply bg-gignetblue-500;
    }

    &:focus-visible {
      @apply ring ring-gignetblue-300 ring-offset-2 ring-opacity-50;
    }

    &:disabled {
      @apply bg-gignetblue-300 cursor-not-allowed shadow-none;
    }
  }

  &__spinner {
    @apply inline-block animate-spin;
  }
}

.update-enter-active,
.update-leave-active {
  @apply transition-all duration-300;
}

.update-enter-from,
.update-leave-to {
  @apply opacity-0;
  transform: translateY(1rem);
}
</style>
